import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	isUncancelable: ForNodeType<boolean>;
	onSetViewModel: (
		values: {
			key: "isUncancelable";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const usePlanIsUncancelable = ({ isUncancelable, onSetViewModel }: Props) => {
	const onSetIsUncancelable = (value: boolean) => {
		onSetViewModel([
			{
				key: "isUncancelable",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		isUncancelable,
		onSetIsUncancelable,
	};
};
